export interface DataProviderItem {
    id?: string;
    text: string;
}

export interface RemoteDataProviderResponse<T = DataProviderItem> {
    items: T[];
}

export interface DataProvider<T = DataProviderItem> {
    (query: string): Promise<RemoteDataProviderResponse<T>>;
}
